<script setup lang="ts">
import { RouterView } from 'vue-router'
import Navbar from './views/Navbar.vue'
import Alert from './components/Alert.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<i18n lang="yaml">
en:
  loading: Loading
ru:
  loading: Загрузка
</i18n>

<template>
  <div>
    <Navbar />
    <div class="container pt-4 pb-4">
      <Alert />
      <RouterView v-slot="{ Component }">
        <template v-if="Component">
          <Suspense>
            <component :is="Component"></component>
            <template #fallback>{{ t('loading') }}...</template>
          </Suspense>
        </template>
      </RouterView>
    </div>
  </div>
</template>
